import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { WithdrawalReverseConfirmComponent } from './withdrawal-reverse-confirm.component';



@NgModule({
  declarations: [WithdrawalReverseConfirmComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class WithdrawalReverseConfirmModule { }
